import React, { ReactElement } from 'react';
import { Content, Label, Wrapper } from './Droplist.styled';
import { ComponentProps as Props } from './Droplist.types';

const Droplist: React.FC<Props> = ({ children, options, onOptionClick, ...props }): ReactElement<Props> => {
  return (
    <Wrapper {...props}>
      <Content>
        {options.map((option, key) => (
          <Label key={`label-${key}`} selected={option.selected} onClick={() => onOptionClick(option, key)}>
            {option.render ? option.render : option.label}
          </Label>
        ))}
      </Content>
    </Wrapper>
  );
};

export default Droplist;
